import type { CartProduct } from '~types/cart';
import type { Participant } from '~types/participant';

import { getLocale } from './translationHelper';
import { getTargetShopUrl } from './widgetHelper';

type SkierPayload = {
  cc: string;
  opts?: Record<string, string>;
  stud?: string;
  subcontingent?: string;
  subcontingent_opts?: Record<string, string>;
};

type CartItemPayload = {
  s: string;
  sk: SkierPayload[];
  slug: string;
};

export type CartCheckoutPayload = {
  items: CartItemPayload[];
};

const buildSkierPayload = (participant: Participant): SkierPayload => {
  const skier: SkierPayload = { cc: participant.consumerCategory.shortname };

  if (participant.consumerCategory.student) {
    skier.stud = '1';
  }
  if (participant.timeslotExternalId) {
    skier.subcontingent = participant.timeslotExternalId;
  }

  const opts: Record<string, string> = {};
  const subcontingentOpts: Record<string, string> = {};
  for (const option of participant.options) {
    opts[option.slug] = '1';
    if (option.isBooking && option.timeslot?.externalId) {
      subcontingentOpts[option.slug] = option.timeslot.externalId;
    }
  }
  if (Object.keys(opts).length > 0) skier.opts = opts;
  if (Object.keys(subcontingentOpts).length > 0) skier.subcontingent_opts = subcontingentOpts;

  return skier;
};

export const buildCartCheckoutPayload = (products: CartProduct[]): CartCheckoutPayload => ({
  items: products.map((product) => ({
    s: product.date,
    sk: product.participants.map(buildSkierPayload),
    slug: product.productSlug,
  })),
});

export const submitCartCheckout = (products: CartProduct[]): boolean => {
  if (products.length === 0) return false;

  let shopUrl: string;
  try {
    shopUrl = getTargetShopUrl();
  } catch (err) {
    console.error('[cart] Cannot redirect to checkout:', err);
    return false;
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${shopUrl}/${getLocale()}/cart/confirm-all`;
  form.style.display = 'none';

  const input = document.createElement('input');
  input.name = 'cart';
  input.type = 'hidden';
  input.value = JSON.stringify(buildCartCheckoutPayload(products));
  form.appendChild(input);

  document.body.appendChild(form);
  form.submit();
  return true;
};
